import React from 'react';

import {CircularProgress} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import ChecklistTypeCreate from "./ChecklistTypeCreate";


class ChecklistTypeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checklistTypes: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveChecklistTypes();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveChecklistTypes();
        }
    }

    async retrieveChecklistTypes() {
        const url = 'checklist_type/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                checklistTypes: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.checklistTypes) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedTable
                title={'Типы чек-листов'}
                url={'admin/checklist_type'}
                callBack={this.retrieveChecklistTypes.bind(this)}
                extraComponents={[
                    {
                        component: ChecklistTypeCreate,
                        componentProps: {}
                    }
                ]}
                data={this.state.checklistTypes}
                pages={this.state.pages}
                pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                fields={[
                    {
                        title: 'Название',
                        name: 'title',
                        linkPattern: '/admin/checklist_type/detail/:linkParam',
                        linkParam: 'id',
                        linkTarget: '_blank',
                        visible: true,
                    },
                    {
                        title: 'Создано',
                        name: 'created_on',
                        visible: true,
                    },
                    {
                        title: 'Обновлено',
                        name: 'updated_on',
                        visible: true,
                    },
                ]
                }
            />
        )
    }
}

export default withRouter(ChecklistTypeList)